import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { useApolloClient } from "@apollo/client";
import { ChildPropsFromArray } from "types/commons";
import { GetTransportObjectTypesDocument, GetTransportObjectTypesQuery } from "__generated__/view/ships/graphql/ship.queries.generated";

export type ShipCemtClassificationTypeSelectOption = ChildPropsFromArray<GetTransportObjectTypesQuery, "transportObjectTypes">;

const ShipCemtClassificationTypeSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<ShipCemtClassificationTypeSelectOption, Multiple>, "fetchOptions">) => {
	const client = useApolloClient();

	const onFetchOptions = async() => {

		const response = await client.query({
			query: GetTransportObjectTypesDocument,
		});

		return {
			options: response.data.transportObjectTypes ?? [],
			totalResults: response.data.transportObjectTypes?.length ?? 0,
		};
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			getOptionLabel={option => option.canonicalName ?? ""}
			{...rest} />
	);
};

export default ShipCemtClassificationTypeSelect;
